! function(t) {
  function e(e) {
    for (var i, a, s = e[0], u = e[1], c = e[2], l = 0, f = []; l < s.length; l++) a = s[l], Object.prototype.hasOwnProperty.call(r, a) && r[a] && f.push(r[a][0]), r[a] = 0;
    for (i in u) Object.prototype.hasOwnProperty.call(u, i) && (t[i] = u[i]);
    for (d && d(e); f.length;) f.shift()();
    return o.push.apply(o, c || []), n()
  }

  function n() {
    for (var t, e = 0; e < o.length; e++) {
      for (var n = o[e], i = !0, s = 1; s < n.length; s++) {
        var u = n[s];
        0 !== r[u] && (i = !1)
      }
      i && (o.splice(e--, 1), t = a(a.s = n[0]))
    }
    return t
  }
  var i = {},
    r = {
      7: 0
    },
    o = [];

  function a(e) {
    if (i[e]) return i[e].exports;
    var n = i[e] = {
      i: e,
      l: !1,
      exports: {}
    };
    return t[e].call(n.exports, n, n.exports, a), n.l = !0, n.exports
  }
  a.m = t, a.c = i, a.d = function(t, e, n) {
    a.o(t, e) || Object.defineProperty(t, e, {
      enumerable: !0,
      get: n
    })
  }, a.r = function(t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    })
  }, a.t = function(t, e) {
    if (1 & e && (t = a(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var n = Object.create(null);
    if (a.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t)
      for (var i in t) a.d(n, i, function(e) {
        return t[e]
      }.bind(null, i));
    return n
  }, a.n = function(t) {
    var e = t && t.__esModule ? function() {
      return t.default
    } : function() {
      return t
    };
    return a.d(e, "a", e), e
  }, a.o = function(t, e) {
    return Object.prototype.hasOwnProperty.call(t, e)
  }, a.p = "";
  var s = window.shopifySlateJsonp = window.shopifySlateJsonp || [],
    u = s.push.bind(s);
  s.push = e, s = s.slice();
  for (var c = 0; c < s.length; c++) e(s[c]);
  var d = u;
  o.push([100, 0, 1]), n()
}({
  100: function(t, e, n) {
    "use strict";
    var i = n(6);
    n(26), n(142), (0, i.load)("*"), window.requestAnimationFrame = window.requestAnimationFrame || function(t) {
      t()
    },
      function(t) {
        function e(t) {
          t && t.length && !t.hasClass("shown") && t.addClass("shown")
        }
        t(document).ready((function() {
          function n() {
            window.requestAnimationFrame((function() {
              var i = t(".fade-in-section").not(".shown");
              if (i.length)
                for (var r = window.scrollY, o = r + window.innerHeight, a = 0; a < i.length; a++) {
                  var s = t(i[a]),
                    u = s.position().top,
                    c = u + s.outerHeight();
                  (c > r && o > c || u > r && o > u) && e(s)
                } else window.removeEventListener("scroll", n)
            }))
          }
          e(t("#shopify-section-header .header")), n(), window.addEventListener("scroll", n, {
            passive: !0
          })
        }))
      }(jQuery)
  },
  142: function(t, e, n) {
    "use strict";
    var i = n(6),
      r = function(t) {
        return t && t.__esModule ? t : {
          default: t
        }
      }(n(38));
    (0, i.register)("slideshow", {
      onLoad: function() {
        var id = this.id
        var speed = this.container.getAttribute("data-glide-speed") ? parseInt(this.container.getAttribute("data-glide-speed")) : 3000
        var initGlideSlider = function () {
          return new r.default(".glide--" + id, {
            autoplay: speed,
            hoverpause: false
          }).mount()
        }
        var glideSlider = initGlideSlider()
        var playPauseBtn = this.container.querySelector(".js-play-pause")
        if (playPauseBtn) {
          playPauseBtn.addEventListener('click', function () {
            if (glideSlider) {
              if (playPauseBtn.classList.contains('paused')) {
                glideSlider.update({ autoplay: speed })
              } else {
                glideSlider.update({ autoplay: 0 })
              }
              playPauseBtn.classList.toggle('paused')
            }
          })
        }
      }
    })
  },
  17: function(t, e, n) {
    "use strict";
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = {
      "Merino Ponti": {
        desc: "This 100% Merino cozy double-knit material moulds to the body providing a streamlined sillouette with extra stretch and durability."
      },
      "Core Spun Merino": {
        desc: "Allows for lighter weight materials with increased material strength. By wrapping Merino fibres around a nylon filament we increase the strength of the fabric while still maintaining the comfort and odor-resistant properties."
      },
      "ProTech Merino": {
        desc: "A midweight advanced technology Merino wool base layer material designed for all-round use. By wrapping Merino fibres around a nylon filament we increase the strength of the fabric while still maintaining the comfort and odor-resistant properties. The Elastane fibers maintain the next-to-skin fit for maximum thermal efficiency and moisture transfer."
      },
      "Super Soft Merino Light": {
        desc: "We blended our Corespun durable merino with Tencel® for extra gentleness on the skin. Tencel® is a natural material found in the wood pulp of eucalyptus trees while our Corespun technology wraps merino fibers around a nylon filament to increase the strength of the fabric while still maintaining the comfort and odor-resistant properties of Merino."
      },
      "Merino Stretch": {
        desc: "A soft lightweight merino made better by blending a touch of elastane fibers to maintain the next-to-skin fit for maximum thermal efficiency and moisture transfer."
      }
    }
  },
  26: function(t, e, n) {
    "use strict";
    var i = l(n(9)),
      r = l(n(10)),
      o = n(39),
      a = n(35),
      s = n(6),
      u = n(18),
      c = n(36),
      d = l(n(17));

    function l(t) {
      return t && t.__esModule ? t : {
        default: t
      }
    }
    var f = "hide",
      p = {
        isFirstSubmitButtonRender: !0
      },
      h = {
        submitButton: "[data-submit-button]",
        submitButtonText: "[data-submit-button-text]",
        comparePrice: "[data-compare-price]",
        comparePriceText: "[data-compare-text]",
        priceWrapper: "[data-price-wrapper]",
        imageWrapper: "[data-product-image-wrapper]",
        visibleImageWrapper: "[data-product-image-wrapper]:not(.hide)",
        imageWrapperById: function(t) {
          return h.imageWrapper + "[data-image-id='" + t + "']"
        },
        productForm: "[data-product-form]",
        productPrice: "[data-product-price]",
        thumbnail: "[data-product-single-thumbnail]",
        thumbnailById: function(t) {
          return "[data-thumbnail-id='" + t + "']"
        },
        thumbnailActive: "[data-product-single-thumbnail][aria-current]"
      };
    (0, s.register)("product", {
      onLoad: function() {
        var t = this;
        return (0, r.default)(i.default.mark((function e() {
          var n;
          return i.default.wrap((function(e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return console.log("product load"), n = document.querySelector(h.productForm), e.next = 4, t.getProductJson(n.dataset.productHandle);
              case 4:
                t.product = e.sent, t.productForm = new o.ProductForm(n, t.product, {
                  onOptionChange: t.onFormOptionChange.bind(t)
                }), t.onThumbnailClick = t.onThumbnailClick.bind(t), t.onThumbnailKeyup = t.onThumbnailKeyup.bind(t), t.container.addEventListener("click", t.onThumbnailClick), t.container.addEventListener("keyup", t.onThumbnailKeyup), t.selectedOption = document.getElementById("selected-variant"), t.disableSoldoutOptions(), t.selectOptions(), t.sizeGuideTabs(), t.checkFabric();
              case 15:
              case "end":
                return e.stop()
            }
          }), e, t)
        })))()
      },
      onUnload: function() {
        this.productForm.destroy(), this.removeEventListener("click", this.onThumbnailClick), this.removeEventListener("keyup", this.onThumbnailKeyup)
      },
      getProductJson: function(t) {
        return fetch("/products/" + t + ".js").then((function(t) {
          return t.json()
        }))
      },
      onFormOptionChange: function(t) {
        var e = t.dataset.variant;
        this.renderImages(e), this.renderPrice(e), this.renderComparePrice(e), this.renderSubmitButton(e), this.updateBrowserHistory(e), this.disableSoldoutOptions()
      },
      sizeGuideTabs: function(t) {
        var e = this,
          n = this.container.querySelectorAll("#sizing-tabs li"),
          i = this.container.querySelectorAll(".fit-tab-content");
        document.querySelector("#sizing-tabs").addEventListener("click", (function(t) {
          if ("a" === t.target.tagName.toLowerCase()) {
            n.forEach((function(t) {
              t.classList.remove("selected")
            }));
            var r = t.target.hash;
            i.forEach((function(t) {
              t.classList.remove("active")
            })), e.container.querySelector(r).classList.add("active"), t.target.parentNode.classList.add("selected")
          }
        }))
      },
      onThumbnailClick: function(t) {
        var e = t.target.closest(h.thumbnail);
        e && (t.preventDefault(), this.renderFeaturedImage(e.dataset.thumbnailId), this.renderActiveThumbnail(e.dataset.thumbnailId))
      },
      onThumbnailKeyup: function(t) {
        if (13 === t.keyCode && t.target.closest(h.thumbnail)) {
          var e = this.container.querySelector(h.visibleImageWrapper);
          (0, u.forceFocus)(e)
        }
      },
      selectOptions: function() {
        var t = this.product.variants,
          e = this.productForm.optionInputs;
        try {
          t.forEach((function(t, n) {
            if (t.available) throw e.forEach((function(e, n) {
              (t.option1 == $(e).val() && 0 == $(e).data("option-index") || t.option2 == $(e).val() && 1 == $(e).data("option-index") || t.option3 == $(e).val() && 2 == $(e).data("option-index")) && $(e).parent().find("label").click()
            })), BreakException
          }))
        } catch (t) {}
      },
      disableSoldoutOptions: function() {
        var t, e = this.product.variants,
          n = [],
          i = [],
          r = -1;
        this.productForm.optionInputs.forEach((function(t, e) {
          var o = $(t).data("option-index");
          n[o] || (n[o] = []), n[o].push($(t)), $(t).is(":checked") && (i[o] = $(t).val(), r++)
        })), r && function() {
          var r = [];
          for (r[0] = [], r[1] = [], r[2] = [], e.forEach((function(t, e) {
            t.option2 != i[1] && null != i[1] || t.option3 != i[2] && null != i[2] || !t.available || r[0].push(t.option1), t.option1 != i[0] && null != i[0] || t.option3 != i[2] && null != i[2] || !t.available || r[1].push(t.option2), t.option1 != i[0] && null != i[0] || t.option2 != i[1] && null != i[1] || !t.available || r[2].push(t.option3)
          })), t = 0; t <= 3; t++) n[t] && "undefined" !== n[t] && n[t].length > 0 && n[t].forEach((function(e, n) {
            var i = $(e).parent("div.swatch-element");
            i.addClass("soldout").removeClass("available"), $(e).prop("disabled", !0);
            var o = !1;
            r && "undefined" !== r && r.length > 0 && r[t].forEach((function(t) {
              t == $(e).val() && (o = !0)
            })), (o || i.hasClass("color")) && $(e).prop("disabled", !1).parent("div.swatch-element").removeClass("soldout").addClass("available")
          }))
        }()
      },
      backOrderCheck: function(t) {
        var e = parseInt(t.inventoryQty, 10);
        if (e > 0) return theme.strings.addToCart;
        var n = parseInt(t.incomingQty, 10) - 2 + e;
        return t.incomingQty > 0 && n >= 0 && (document.getElementById("backorder-message").innerText = "Expected shipping by " + t.incomingDate, theme.strings.addToCart)
      },
      renderSubmitButton: function(t) {
        var e = this.container.querySelector(h.submitButton),
          n = document.querySelector("#selected-variant option[value='" + t.id + "']");
        document.getElementById("backorder-message").innerText = "";
        var i = this.container.querySelector(h.submitButtonText);
        if (t)
          if (t.available) {
            var r = !0,
              o = !1;
            n.dataset.incoming && (o = r = this.backOrderCheck(n.dataset)), r ? (e.disabled = !1, i.innerText = o || theme.strings.addToCart) : (e.disabled = !0, i.innerText = theme.strings.soldOut), p.isFirstSubmitButtonRender && (e.addEventListener("click", c.CartModal.openModal.bind(this)), p.isFirstSubmitButtonRender = !1)
          } else e.disabled = !0, i.innerText = theme.strings.soldOut;
        else e.disabled = !0, i.innerText = theme.strings.unavailable
      },
      renderImages: function(t) {
        t && null !== t.featured_image && (this.renderFeaturedImage(t.featured_image.id), this.renderActiveThumbnail(t.featured_image.id))
      },
      renderPrice: function(t) {
        var e = this.container.querySelector(h.productPrice);
        this.container.querySelector(h.priceWrapper).classList.toggle(f, !t), t && (e.innerText = (0, a.formatMoney)(t.price, theme.moneyFormat))
      },
      renderComparePrice: function(t) {
        if (t) {
          var e = this.container.querySelector(h.comparePrice),
            n = this.container.querySelector(h.comparePriceText);
          e && n && (t.compare_at_price > t.price ? (e.innerText = (0, a.formatMoney)(t.compare_at_price, theme.moneyFormat), n.classList.remove(f), e.classList.remove(f)) : (e.innerText = "", n.classList.add(f), e.classList.add(f)))
        }
      },
      renderActiveThumbnail: function(t) {
        var e = this.container.querySelector(h.thumbnailById(t)),
          n = this.container.querySelector(h.thumbnailActive);
        e !== n && (n.removeAttribute("aria-current"), e.setAttribute("aria-current", !0))
      },
      renderFeaturedImage: function(t) {
        var e = this.container.querySelector(h.visibleImageWrapper),
          n = this.container.querySelector(h.imageWrapperById(t));
        e && e.classList.add(f), n && n.classList.remove(f)
      },
      updateBrowserHistory: function(t) {
        var e = this.productForm.element.dataset.enableHistoryState;
        if (t && "true" === e) {
          var n = (0, o.getUrlWithVariant)(window.location.href, t.id);
          window.history.replaceState({
            path: n
          }, "", n)
        }
      },
      checkFabric: function() {
        var t = document.getElementById("primary-fabric");
        if (null !== t) {
          var e = t.dataset.fabric,
            n = d.default[e];
          t.querySelector(".content p").innerHTML = n.desc
        }
      }
    })
  },
  36: function(t, e, n) {
    "use strict";
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.CartModal = void 0;
    var i = a(n(37)),
      r = a(n(9)),
      o = a(n(10));

    function a(t) {
      return t && t.__esModule ? t : {
        default: t
      }
    }
    e.CartModal = function(t) {
      var e = function() {
          var t = (0, o.default)(r.default.mark((function t(e) {
            var n, i, o;
            return r.default.wrap((function(t) {
              for (;;) switch (t.prev = t.next) {
                case 0:
                  return n = document.getElementById("Quantity").value, e.preventDefault(), e.stopPropagation(), this.product.variant_id = x(this.product, "id", f.mainProductWrapper), t.next = 6, s(this.product, n);
                case 6:
                  return i = t.sent, t.next = 9, d(this.product.id, 3);
                case 9:
                  o = t.sent, g(i, o);
                case 11:
                case "end":
                  return t.stop()
              }
            }), t, this)
          })));
          return function(e) {
            return t.apply(this, arguments)
          }
        }(),
        n = function() {
          var e = (0, o.default)(r.default.mark((function e(n) {
            return r.default.wrap((function(e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", t.get("/products/" + n + ".js", (function(t) {
                    return t
                  }), "json"));
                case 1:
                case "end":
                  return e.stop()
              }
            }), e, this)
          })));
          return function(t) {
            return e.apply(this, arguments)
          }
        }(),
        a = function() {
          var e = (0, o.default)(r.default.mark((function e() {
            return r.default.wrap((function(e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", t.ajax({
                    url: "/cart.js",
                    type: "GET",
                    dataType: "JSON",
                    success: function(t) {
                      return t
                    }
                  }));
                case 1:
                case "end":
                  return e.stop()
              }
            }), e, this)
          })));
          return function() {
            return e.apply(this, arguments)
          }
        }(),
        s = function() {
          var e = (0, o.default)(r.default.mark((function e(n) {
            var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
            return r.default.wrap((function(e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", t.post("/cart/add.js", {
                    quantity: i,
                    id: n.variant_id
                  }, (function(t) {
                    return t
                  }), "json"));
                case 1:
                case "end":
                  return e.stop()
              }
            }), e, this)
          })));
          return function(t) {
            return e.apply(this, arguments)
          }
        }(),
        u = function() {
          var e = (0, o.default)(r.default.mark((function e(n, o) {
            return r.default.wrap((function(e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", t.post("/cart/update.js", {
                    updates: (0, i.default)({}, n, o)
                  }, (function(t) {
                    return t
                  }), "json"));
                case 1:
                case "end":
                  return e.stop()
              }
            }), e, this)
          })));
          return function(t, n) {
            return e.apply(this, arguments)
          }
        }(),
        c = function() {
          var e = (0, o.default)(r.default.mark((function e(n) {
            var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
            return r.default.wrap((function(e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", t.post("/cart/add.js", {
                    quantity: i,
                    id: n
                  }, (function(t) {
                    return t
                  }), "json"));
                case 1:
                case "end":
                  return e.stop()
              }
            }), e, this)
          })));
          return function(t) {
            return e.apply(this, arguments)
          }
        }(),
        d = function() {
          var e = (0, o.default)(r.default.mark((function e(n) {
            var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
            return r.default.wrap((function(e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", t.get("/recommendations/products.json?product_id=" + n + "&limit=" + i, (function(t) {
                    return t
                  }), "json"));
                case 1:
                case "end":
                  return e.stop()
              }
            }), e, this)
          })));
          return function(t) {
            return e.apply(this, arguments)
          }
        }(),
        l = a(),
        f = {
          mainProductWrapper: "#shopify-section-product",
          modal: "#cart-modal-template",
          closeModal: "[btn-close]",
          productTable: "[cart-wrapper]",
          product: "[data-product]",
          title: "[data-title]",
          image: "[data-img]",
          url: "[data-product-url]",
          price: "[data-price]",
          priceDiscount: "[data-price-discount]",
          variants: "[data-variants]",
          variant: "[data-variant]",
          amount: "[data-product-amount]",
          delete: "[data-delete]",
          cartGroupButton: ".cart-button",
          cartButton: ".cart-button .item-count"
        },
        p = {
          enable: "[re-ajax-enable]",
          loopWrapper: "[re-wrapper-loop]",
          wrapper: "[re-wrapper]",
          header: "[re-header]",
          product: "[re-product]",
          productLoopWrapper: "[re-product-loop]",
          productImage: "[re-product-image]",
          productVariants: "[re-product-variants]",
          productAmount: "[re-product-amount]",
          productAddToCart: "[re-product-add-to-cart]",
          productAmountUp: "[re-product-amount-up]",
          productAmountDown: "[re-product-amount-down]",
          productOptionsContainer: "[re-product-option-container]",
          productOptionsLoop: "[re-product-option-loop]",
          productOptionSwatchItem: "[re-product-option]",
          productOptionItemValue: "[re-product-option-value]",
          productSubmit: "[re-product-add-to-cart ]",
          productSubtitle: "[re-subtitle]",
          productData: "[re-product-data]",
          pagination: "#carousel [re-pagination]",
          paginationItem: "[re-pagination-item]"
        },
        h = {
          sizeInput: 'input:nameCaseInsensitive("options[size]"):checked',
          colorInput: 'input:nameCaseInsensitive("options[color]"):checked',
          giftInput: 'input:nameCaseInsensitive("options[denominations]"):checked'
        },
        m = t(f.modal).find(f.product),
        v = Number(t(f.modal + " " + p.wrapper).find(p.enable).first().attr("re-ajax-enable"));

      function g(e, i) {
        l.then((function(a) {
          if (0 === a.items.length) a.items.push(e);
          else {
            var s = !1;
            a.items = a.items.map((function(t) {
              return t.id === e.id ? (s = !0, e) : t
            })), s || a.items.push(e)
          }
          return a.item_count++,
            function(e) {
              var n = this;
              t(f.productTable).empty(), 0 !== t(f.cartButton).length ? t(f.cartButton).html(e.item_count) : t(f.cartGroupButton).append('<span class="item-count">' + e.item_count + "</span>");
              for (var i = function(i) {
                var a = e.items[i],
                  s = t(m).clone();
                s.find(f.image).append('<img src="' + a.featured_image.url + '" alt="' + a.featured_image.alt + '" />'), s.find(f.url).attr("href", a.url), s.find(f.title).html(a.product_title), s.find(f.price).html(O(a.final_line_price)), a.options_with_values && a.options_with_values.forEach((function(t, e) {
                  var n = s.find(f.variant).clone();
                  0 === e && s.find(f.variants).empty(), n.html("<b>" + t.name + "</b>: " + t.value), s.find(f.variants).append(n)
                })), a.discounted_price != a.price && s.find(f.priceDiscount).html(O(a.discounted_price));
                for (var c = 1; c <= 15; c++) {
                  var d = '<option value="' + c + '" ' + (c === a.quantity ? "selected" : "") + ">" + c + "</option>";
                  s.find(f.amount).append(d)
                }
                s.find(f.amount).on("change", function() {
                  var e = (0, o.default)(r.default.mark((function e(i) {
                    var o, s;
                    return r.default.wrap((function(e) {
                      for (;;) switch (e.prev = e.next) {
                        case 0:
                          return o = i.target.value, e.next = 3, u(a.id, o);
                        case 3:
                          if (!(s = e.sent).hasOwnProperty("status")) {
                            e.next = 6;
                            break
                          }
                          throw new Error(s.message);
                        case 6:
                          t(window.location).attr("href", "/cart");
                        case 7:
                        case "end":
                          return e.stop()
                      }
                    }), e, n)
                  })));
                  return function(t) {
                    return e.apply(this, arguments)
                  }
                }()), s.find(f.delete).attr("href", "/cart/change?line=" + (i + 1) + "&amp;quantity=0");
                var l = t(".cart-checkout .button-group").clone();
                t(".cart-checkout").html(l), t(f.productTable).append(s);
                var p = t(f.modal);

                function h() {
                  p.css("display", "none"), p.off("transitionend", h)
                }
                p.css("display", "inline-block"), window.setTimeout((function() {
                  p.addClass("active")
                }), 0), p.find(f.closeModal).one("click", (function() {
                  p.removeClass("active"), p.on("transitionend", h)
                }))
              }, a = 0; a < e.items.length; a++) i(a)
            }(a), v ? function(e) {
            var n = this;
            if (e.hasOwnProperty("products")) {
              var i = t(p.loopWrapper).clone();
              e.products.forEach((function(e, r) {
                var o = !0;
                1 === e.options.length && "Title" === e.options[0].name && (o = !1);
                var a = i.clone();
                0 === r && (t(p.wrapper).empty(), a.addClass("active")), a.find(p.productImage).html('<a href="' + e.url + '"><img src="' + e.featured_image + '" /></a>'), o ? a.find(p.productImage).removeClass("full-width") : a.find(p.productImage).addClass("full-width"), a.find(p.productAmount).val(1), a.find(p.productVariants).css("display", o ? "initial" : "none"), e.options.forEach((function(i) {
                  var r = t(a).find(p.productOptionsLoop + "[" + i.name.toLowerCase() + "]");
                  r.closest(p.productOptionsContainer).css("display", "inherit");
                  var o = r.find(p.productOptionSwatchItem).first().clone();
                  r.empty(), i.values.forEach((function(t, s) {
                    var u = o.clone(),
                      c = u.find("input");
                    u.attr("data-swatch", t), c.attr("id", "Recommendation-Option" + s + "-" + t + "-" + e.id), c.attr("name", "options[" + i.name + "]"), c.attr("data-option-index", s), 0 === s && (c.prop("checked", !0), u.addClass("active"), a.find(p.productOptionItemValue + "[" + i.name.toLowerCase() + "]").html(t)), c.val(t), c.on("change", _.bind(n, r, u, a)), c.on("change", (function() {
                      S(e, i, t, a)(), w(e, a), b(e, a.find(p.product))
                    }));
                    var d = u.find("label");
                    switch (d.attr("for", "Recommendation-Option" + s + "-" + t + "-" + e.id), i.name.toLowerCase()) {
                      case "color":
                        var l = t.toLowerCase().split(" "),
                          f = l[l.length - 1];
                        d.css({
                          "background-color": f
                        });
                        break;
                      case "size":
                        d.html(t)
                    }
                    r.append(u)
                  }))
                })), a.find(p.productAddToCart).on("click", (function(n) {
                  n.preventDefault(), n.stopPropagation(), c(x(e, "id", a), Number(a.find(p.productAmount).val())).then((function(e) {
                    return e && t(window.location).attr("href", "/cart"), !0
                  }))
                })), a.find(p.productAmountUp).on("click", (function(t) {
                  t.preventDefault(), t.stopPropagation(), k(a, 1)
                })), a.find(p.productAmountDown).on("click", (function(t) {
                  t.preventDefault(), t.stopPropagation(), k(a, -1)
                })), w(e, a), b(e, a.find(p.product)), t(p.wrapper).append(a)
              })),
                function(e) {
                  var n = t(p.pagination),
                    i = n.find(p.paginationItem).first().clone();
                  n.empty();
                  for (var r = 0; r < e; r++) {
                    var o = i.clone();
                    o.attr("data-slide-to", r), 0 === r && o.addClass("active"), n.append(o)
                  }
                }(e.products.length)
            }
          }(i) : function() {
            var e = this;
            t(f.modal).find(p.product).each(function() {
              var i = (0, o.default)(r.default.mark((function i(o, a) {
                var s, u;
                return r.default.wrap((function(i) {
                  for (;;) switch (i.prev = i.next) {
                    case 0:
                      return s = t(a), i.next = 3, n(s.attr("re-handle"));
                    case 3:
                      u = i.sent, s.find(p.productOptionSwatchItem).each((function(n, i) {
                        var r = t(i),
                          o = t(s).find(p.productOptionsLoop + "[" + r.attr("option").toLowerCase() + "]"),
                          a = s;
                        r.find("input").on("change", _.bind(e, o, r, a)), r.find("input").on("change", (function() {
                          var e = u.options.reduce((function(t, e) {
                              return e.name.toLowerCase() === r.attr("option") ? e : t
                            })),
                            n = t(this).val();
                          S(u, e, n, a)(), w(u, s), y(s)
                        })), y(s)
                      })), s.find(p.productAmountUp).off(), s.find(p.productAmountUp).on("click", (function(t) {
                        t.preventDefault(), t.stopPropagation(), k(s, 1)
                      })), s.find(p.productAmountDown).off(), s.find(p.productAmountDown).on("click", (function(t) {
                        t.preventDefault(), t.stopPropagation(), k(s, -1)
                      })), s.find(p.productSubmit).off(), s.find(p.productSubmit).on("click", (function(e) {
                        e.preventDefault(), e.stopPropagation();
                        var n = x(u, "id", s),
                          i = s.find(p.productAmount).val();
                        c(n, i).then((function(e) {
                          return e && t(window.location).attr("href", "/cart"), !0
                        }))
                      }));
                    case 12:
                    case "end":
                      return i.stop()
                  }
                }), i, e)
              })));
              return function(t, e) {
                return i.apply(this, arguments)
              }
            }())
          }(), !0
        })).catch((function(t) {
          throw new Error(t)
        }))
      }

      function b(t, e) {
        var n = x(t, "id", e),
          i = t.variants.reduce((function(t, e) {
            return e.id === n ? e : t
          })),
          r = i.featured_image ? i.featured_image.src : t.featured_image;
        e.find(p.productImage).find("img").attr("src", r)
      }

      function y(e) {
        var n = e.find(p.productData).find("[re-product-image]").filter((function() {
            var n = function(t) {
                var e = {},
                  n = ["color", "size", "background"],
                  i = t.trim().split(";").map((function(t) {
                    return t.trim()
                  })),
                  r = !0,
                  o = !1,
                  a = void 0;
                try {
                  for (var s, u = i[Symbol.iterator](); !(r = (s = u.next()).done); r = !0) {
                    var c = s.value.split(":").map((function(t) {
                        return t.trim()
                      })),
                      d = c[0].toLowerCase(); - 1 !== n.indexOf(d) && (e[d.trim()] = c[1].toLowerCase().split(",").map((function(t) {
                      return t.trim()
                    })))
                  }
                } catch (t) {
                  o = !0, a = t
                } finally {
                  try {
                    !r && u.return && u.return()
                  } finally {
                    if (o) throw a
                  }
                }
                return e
              }(t(this).attr("alt")),
              i = e.find(h.colorInput),
              r = i.length ? i.val().toLowerCase() : void 0,
              o = n.hasOwnProperty("color") && -1 !== n.color.indexOf(r),
              a = n.hasOwnProperty("background") && -1 !== n.background.indexOf("grey");
            return o && a
          })),
          i = e.find(p.productImage).find("img");
        n.length ? (i.attr("src", n.attr("src")), i.attr("alt", n.attr("alt")), i.css("opacity", "1")) : i.css("opacity", "0")
      }

      function w(t, e) {
        var n = x(t, "id", e),
          i = t.variants.reduce((function(t, e) {
            return e.id === n ? e : t
          }));
        e.find(p.productSubtitle).html(O(i.price) + " - " + t.title)
      }

      function k(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
          n = Number(t.find(p.productAmount).val());
        t.find(p.productAmount).val(n + e === 0 ? 1 : n + e)
      }

      function _(t, e, n) {
        var i = e.find("input:checked").val();
        t.find(p.productOptionSwatchItem).removeClass("active"), e.addClass("active"), n.find(p.productOptionItemValue + "[" + e.attr("option").toLowerCase() + "]").html(i)
      }

      function S(e, n, i, r) {
        var o = ["color"];
        return function() {
          e.options.forEach((function(t) {
            var a = n !== t,
              s = -1 === o.indexOf(t.name.toLowerCase());
            t.values.forEach((function(n) {
              if (a && s) {
                for (var o = r.find(p.productOptionsLoop + "[" + t.name.toLowerCase() + "]"), u = o.find(p.productOptionSwatchItem + '[data-swatch="' + n + '"]'), c = o.find(p.productOptionSwatchItem + " input:checked"), d = void 0, l = void 0, f = 0; f < e.variants.length; f++) {
                  var h = -1 !== e.variants[f].options.indexOf(i),
                    m = -1 !== e.variants[f].options.indexOf(n),
                    v = -1 !== e.variants[f].options.indexOf(c.val());
                  h && m && (d = e.variants[f]), h && v && (l = e.variants[f])
                }
                d && d.available ? (u.addClass("available"), u.find("input").removeAttr("disabled"), u.removeClass("unavailable"), l && l.available || (o.find(p.productOptionSwatchItem).removeClass("active"), u.find("input").prop("checked", !0), u.addClass("active"), r.find(p.productOptionItemValue + "[" + t.name.toLowerCase() + "]").html(n))) : (u.addClass("unavailable"), u.find("input").prop("disabled", !0), u.removeClass("available"))
              }
            }))
          })),
            function(e) {
              var n = e.find("" + p.productOptionsLoop),
                i = e.find(p.productSubmit),
                r = !1;
              n.each((function(e, n) {
                0 === t(n).find(p.productOptionSwatchItem + " input:not(:disabled)").length && (r = !0)
              })), r ? (i.prop("disabled", !0), i.val(i.attr("disabled-text"))) : (i.removeAttr("disabled"), i.val(i.attr("default-text")))
            }(r)
        }
      }

      function x(e) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "id",
          i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : document;
        if ("ibex-gift-card" == e.handle) {
          for (var r = t(i).find(h.giftInput), o = 0; o < e.variants.length; o++)
            if (0 === r.length || -1 !== e.variants[o].options.indexOf(r.val())) return e.variants[o][n];
          return !1
        }
        for (var a = t(i).find(h.sizeInput), s = t(i).find(h.colorInput), u = 0; u < e.variants.length; u++) {
          var c = 0 === a.length || -1 !== e.variants[u].options.indexOf(a.val()),
            d = 0 === s.length || -1 !== e.variants[u].options.indexOf(s.val());
          if (c && d) return e.variants[u][n]
        }
        return !1
      }

      function O(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "USD",
          n = (t / 100).toLocaleString("en-US", {
            style: "currency",
            currency: e,
            currencyDisplay: "symbol",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          });
        return n.replace(/^([^\d\.\,\s]+)(\d)/, (function(t, e, n) {
          return e + " " + n
        }))
      }
      return {
        openModal: e
      }
    }(jQuery)
  },
  38: function(t, e, n) {
    "use strict";
    n.r(e);
/*!
 * Glide.js v3.4.1
 * (c) 2013-2019 Jędrzej Chałubek <jedrzej.chalubek@gmail.com> (http://jedrzejchalubek.com/)
 * Released under the MIT License.
 */
var i={type:"slider",startAt:0,perView:1,focusAt:0,gap:10,autoplay:!1,hoverpause:!0,keyboard:!0,bound:!1,swipeThreshold:80,dragThreshold:120,perTouch:!1,touchRatio:.5,touchAngle:45,animationDuration:400,rewind:!0,rewindDuration:800,animationTimingFunc:"cubic-bezier(.165, .840, .440, 1)",throttle:10,direction:"ltr",peek:0,breakpoints:{},classes:{direction:{ltr:"glide--ltr",rtl:"glide--rtl"},slider:"glide--slider",carousel:"glide--carousel",swipeable:"glide--swipeable",dragging:"glide--dragging",cloneSlide:"glide__slide--clone",activeNav:"glide__bullet--active",activeSlide:"glide__slide--active",disabledArrow:"glide__arrow--disabled"}};function r(t){console.error("[Glide warn]: "+t)}var o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},a=function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")},s=function(){function t(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}return function(e,n,i){return n&&t(e.prototype,n),i&&t(e,i),e}}(),u=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var i in n)Object.prototype.hasOwnProperty.call(n,i)&&(t[i]=n[i])}return t},c=function(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e};function d(t){return parseInt(t)}function l(t){return"string"==typeof t}function f(t){var e=void 0===t?"undefined":o(t);return"function"===e||"object"===e&&!!t}function p(t){return"function"==typeof t}function h(t){return void 0===t}function m(t){return t.constructor===Array}function v(t,e,n){Object.defineProperty(t,e,n)}function g(t,e){var n=u({},t,e);return e.hasOwnProperty("classes")&&(n.classes=u({},t.classes,e.classes),e.classes.hasOwnProperty("direction")&&(n.classes.direction=u({},t.classes.direction,e.classes.direction))),e.hasOwnProperty("breakpoints")&&(n.breakpoints=u({},t.breakpoints,e.breakpoints)),n}var b=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};a(this,t),this.events=e,this.hop=e.hasOwnProperty}return s(t,[{key:"on",value:function(t,e){if(m(t))for(var n=0;n<t.length;n++)this.on(t[n],e);this.hop.call(this.events,t)||(this.events[t]=[]);var i=this.events[t].push(e)-1;return{remove:function(){delete this.events[t][i]}}}},{key:"emit",value:function(t,e){if(m(t))for(var n=0;n<t.length;n++)this.emit(t[n],e);this.hop.call(this.events,t)&&this.events[t].forEach((function(t){t(e||{})}))}}]),t}(),y=function(){function t(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};a(this,t),this._c={},this._t=[],this._e=new b,this.disabled=!1,this.selector=e,this.settings=g(i,n),this.index=this.settings.startAt}return s(t,[{key:"mount",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return this._e.emit("mount.before"),f(t)?this._c=function(t,e,n){var i={};for(var o in e)p(e[o])?i[o]=e[o](t,i,n):r("Extension must be a function");for(var a in i)p(i[a].mount)&&i[a].mount();return i}(this,t,this._e):r("You need to provide a object on `mount()`"),this._e.emit("mount.after"),this}},{key:"mutate",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[];return m(t)?this._t=t:r("You need to provide a array on `mutate()`"),this}},{key:"update",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return this.settings=g(this.settings,t),t.hasOwnProperty("startAt")&&(this.index=t.startAt),this._e.emit("update"),this}},{key:"go",value:function(t){return this._c.Run.make(t),this}},{key:"move",value:function(t){return this._c.Transition.disable(),this._c.Move.make(t),this}},{key:"destroy",value:function(){return this._e.emit("destroy"),this}},{key:"play",value:function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];return t&&(this.settings.autoplay=t),this._e.emit("play"),this}},{key:"pause",value:function(){return this._e.emit("pause"),this}},{key:"disable",value:function(){return this.disabled=!0,this}},{key:"enable",value:function(){return this.disabled=!1,this}},{key:"on",value:function(t,e){return this._e.on(t,e),this}},{key:"isType",value:function(t){return this.settings.type===t}},{key:"settings",get:function(){return this._o},set:function(t){f(t)?this._o=t:r("Options must be an `object` instance.")}},{key:"index",get:function(){return this._i},set:function(t){this._i=d(t)}},{key:"type",get:function(){return this.settings.type}},{key:"disabled",get:function(){return this._d},set:function(t){this._d=!!t}}]),t}();function w(){return(new Date).getTime()}function k(t,e,n){var i=void 0,r=void 0,o=void 0,a=void 0,s=0;n||(n={});var u=function(){s=!1===n.leading?0:w(),i=null,a=t.apply(r,o),i||(r=o=null)},c=function(){var c=w();s||!1!==n.leading||(s=c);var d=e-(c-s);return r=this,o=arguments,d<=0||d>e?(i&&(clearTimeout(i),i=null),s=c,a=t.apply(r,o),i||(r=o=null)):i||!1===n.trailing||(i=setTimeout(u,d)),a};return c.cancel=function(){clearTimeout(i),s=0,i=r=o=null},c}var _={ltr:["marginLeft","marginRight"],rtl:["marginRight","marginLeft"]};function S(t){if(t&&t.parentNode){for(var e=t.parentNode.firstChild,n=[];e;e=e.nextSibling)1===e.nodeType&&e!==t&&n.push(e);return n}return[]}function x(t){return!!(t&&t instanceof window.HTMLElement)}var O='[data-glide-el="track"]',T=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};a(this,t),this.listeners=e}return s(t,[{key:"on",value:function(t,e,n){var i=arguments.length>3&&void 0!==arguments[3]&&arguments[3];l(t)&&(t=[t]);for(var r=0;r<t.length;r++)this.listeners[t[r]]=n,e.addEventListener(t[r],this.listeners[t[r]],i)}},{key:"off",value:function(t,e){var n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];l(t)&&(t=[t]);for(var i=0;i<t.length;i++)e.removeEventListener(t[i],this.listeners[t[i]],n)}},{key:"destroy",value:function(){delete this.listeners}}]),t}(),C=["ltr","rtl"],L={">":"<","<":">","=":"="};function A(t,e){return{modify:function(t){return e.Direction.is("rtl")?-t:t}}}var P=!1;try{var I=Object.defineProperty({},"passive",{get:function(){P=!0}});window.addEventListener("testPassive",null,I),window.removeEventListener("testPassive",null,I)}catch(t){}var M=P,E=["touchstart","mousedown"],H=["touchmove","mousemove"],j=["touchend","touchcancel","mouseup","mouseleave"],D=["mousedown","mousemove","mouseup","mouseleave"];function B(t){return f(t)?function(t){return Object.keys(t).sort().reduce((function(e,n){return e[n]=t[n],e[n],e}),{})}(t):(r("Breakpoints option must be an object"),{})}var z={Html:function(t,e){var n={mount:function(){this.root=t.selector,this.track=this.root.querySelector(O),this.slides=Array.prototype.slice.call(this.wrapper.children).filter((function(e){return!e.classList.contains(t.settings.classes.cloneSlide)}))}};return v(n,"root",{get:function(){return n._r},set:function(t){l(t)&&(t=document.querySelector(t)),x(t)?n._r=t:r("Root element must be a existing Html node")}}),v(n,"track",{get:function(){return n._t},set:function(t){x(t)?n._t=t:r("Could not find track element. Please use "+O+" attribute.")}}),v(n,"wrapper",{get:function(){return n.track.children[0]}}),n},Translate:function(t,e,n){var i={set:function(n){var i=function(t,e,n){var i=[function(t,e){return{modify:function(n){return n+e.Gaps.value*t.index}}},function(t,e){return{modify:function(t){return t+e.Clones.grow/2}}},function(t,e){return{modify:function(n){if(t.settings.focusAt>=0){var i=e.Peek.value;return f(i)?n-i.before:n-i}return n}}},function(t,e){return{modify:function(n){var i=e.Gaps.value,r=e.Sizes.width,o=t.settings.focusAt,a=e.Sizes.slideWidth;return"center"===o?n-(r/2-a/2):n-a*o-i*o}}}].concat(t._t,[A]);return{mutate:function(o){for(var a=0;a<i.length;a++){var s=i[a];p(s)&&p(s().modify)?o=s(t,e,n).modify(o):r("Transformer should be a function that returns an object with `modify()` method")}return o}}}(t,e).mutate(n);e.Html.wrapper.style.transform="translate3d("+-1*i+"px, 0px, 0px)"},remove:function(){e.Html.wrapper.style.transform=""}};return n.on("move",(function(r){var o=e.Gaps.value,a=e.Sizes.length,s=e.Sizes.slideWidth;return t.isType("carousel")&&e.Run.isOffset("<")?(e.Transition.after((function(){n.emit("translate.jump"),i.set(s*(a-1))})),i.set(-s-o*a)):t.isType("carousel")&&e.Run.isOffset(">")?(e.Transition.after((function(){n.emit("translate.jump"),i.set(0)})),i.set(s*a+o*a)):i.set(r.movement)})),n.on("destroy",(function(){i.remove()})),i},Transition:function(t,e,n){var i=!1,r={compose:function(e){var n=t.settings;return i?e+" 0ms "+n.animationTimingFunc:e+" "+this.duration+"ms "+n.animationTimingFunc},set:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"transform";e.Html.wrapper.style.transition=this.compose(t)},remove:function(){e.Html.wrapper.style.transition=""},after:function(t){setTimeout((function(){t()}),this.duration)},enable:function(){i=!1,this.set()},disable:function(){i=!0,this.set()}};return v(r,"duration",{get:function(){var n=t.settings;return t.isType("slider")&&e.Run.offset?n.rewindDuration:n.animationDuration}}),n.on("move",(function(){r.set()})),n.on(["build.before","resize","translate.jump"],(function(){r.disable()})),n.on("run",(function(){r.enable()})),n.on("destroy",(function(){r.remove()})),r},Direction:function(t,e,n){var i={mount:function(){this.value=t.settings.direction},resolve:function(t){var e=t.slice(0,1);return this.is("rtl")?t.split(e).join(L[e]):t},is:function(t){return this.value===t},addClass:function(){e.Html.root.classList.add(t.settings.classes.direction[this.value])},removeClass:function(){e.Html.root.classList.remove(t.settings.classes.direction[this.value])}};return v(i,"value",{get:function(){return i._v},set:function(t){C.indexOf(t)>-1?i._v=t:r("Direction value must be `ltr` or `rtl`")}}),n.on(["destroy","update"],(function(){i.removeClass()})),n.on("update",(function(){i.mount()})),n.on(["build.before","update"],(function(){i.addClass()})),i},Peek:function(t,e,n){var i={mount:function(){this.value=t.settings.peek}};return v(i,"value",{get:function(){return i._v},set:function(t){f(t)?(t.before=d(t.before),t.after=d(t.after)):t=d(t),i._v=t}}),v(i,"reductor",{get:function(){var e=i.value,n=t.settings.perView;return f(e)?e.before/n+e.after/n:2*e/n}}),n.on(["resize","update"],(function(){i.mount()})),i},Sizes:function(t,e,n){var i={setupSlides:function(){for(var t=this.slideWidth+"px",n=e.Html.slides,i=0;i<n.length;i++)n[i].style.width=t},setupWrapper:function(t){e.Html.wrapper.style.width=this.wrapperSize+"px"},remove:function(){for(var t=e.Html.slides,n=0;n<t.length;n++)t[n].style.width="";e.Html.wrapper.style.width=""}};return v(i,"length",{get:function(){return e.Html.slides.length}}),v(i,"width",{get:function(){return e.Html.root.offsetWidth}}),v(i,"wrapperSize",{get:function(){return i.slideWidth*i.length+e.Gaps.grow+e.Clones.grow}}),v(i,"slideWidth",{get:function(){return i.width/t.settings.perView-e.Peek.reductor-e.Gaps.reductor}}),n.on(["build.before","resize","update"],(function(){i.setupSlides(),i.setupWrapper()})),n.on("destroy",(function(){i.remove()})),i},Gaps:function(t,e,n){var i={apply:function(t){for(var n=0,i=t.length;n<i;n++){var r=t[n].style,o=e.Direction.value;r[_[o][0]]=0!==n?this.value/2+"px":"",n!==t.length-1?r[_[o][1]]=this.value/2+"px":r[_[o][1]]=""}},remove:function(t){for(var e=0,n=t.length;e<n;e++){var i=t[e].style;i.marginLeft="",i.marginRight=""}}};return v(i,"value",{get:function(){return d(t.settings.gap)}}),v(i,"grow",{get:function(){return i.value*(e.Sizes.length-1)}}),v(i,"reductor",{get:function(){var e=t.settings.perView;return i.value*(e-1)/e}}),n.on(["build.after","update"],k((function(){i.apply(e.Html.wrapper.children)}),30)),n.on("destroy",(function(){i.remove(e.Html.wrapper.children)})),i},Move:function(t,e,n){var i={mount:function(){this._o=0},make:function(){var t=this,i=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0;this.offset=i,n.emit("move",{movement:this.value}),e.Transition.after((function(){n.emit("move.after",{movement:t.value})}))}};return v(i,"offset",{get:function(){return i._o},set:function(t){i._o=h(t)?0:d(t)}}),v(i,"translate",{get:function(){return e.Sizes.slideWidth*t.index}}),v(i,"value",{get:function(){var t=this.offset,n=this.translate;return e.Direction.is("rtl")?n+t:n-t}}),n.on(["build.before","run"],(function(){i.make()})),i},Clones:function(t,e,n){var i={mount:function(){this.items=[],t.isType("carousel")&&(this.items=this.collect())},collect:function(){for(var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],i=e.Html.slides,r=t.settings,o=r.perView,a=r.classes,s=o+ +!!t.settings.peek,u=i.slice(0,s),c=i.slice(-s),d=0;d<Math.max(1,Math.floor(o/i.length));d++){for(var l=0;l<u.length;l++){var f=u[l].cloneNode(!0);f.classList.add(a.cloneSlide),n.push(f)}for(var p=0;p<c.length;p++){var h=c[p].cloneNode(!0);h.classList.add(a.cloneSlide),n.unshift(h)}}return n},append:function(){for(var t=this.items,n=e.Html,i=n.wrapper,r=n.slides,o=Math.floor(t.length/2),a=t.slice(0,o).reverse(),s=t.slice(o,t.length),u=e.Sizes.slideWidth+"px",c=0;c<s.length;c++)i.appendChild(s[c]);for(var d=0;d<a.length;d++)i.insertBefore(a[d],r[0]);for(var l=0;l<t.length;l++)t[l].style.width=u},remove:function(){for(var t=this.items,n=0;n<t.length;n++)e.Html.wrapper.removeChild(t[n])}};return v(i,"grow",{get:function(){return(e.Sizes.slideWidth+e.Gaps.value)*i.items.length}}),n.on("update",(function(){i.remove(),i.mount(),i.append()})),n.on("build.before",(function(){t.isType("carousel")&&i.append()})),n.on("destroy",(function(){i.remove()})),i},Resize:function(t,e,n){var i=new T,r={mount:function(){this.bind()},bind:function(){i.on("resize",window,k((function(){n.emit("resize")}),t.settings.throttle))},unbind:function(){i.off("resize",window)}};return n.on("destroy",(function(){r.unbind(),i.destroy()})),r},Build:function(t,e,n){var i={mount:function(){n.emit("build.before"),this.typeClass(),this.activeClass(),n.emit("build.after")},typeClass:function(){e.Html.root.classList.add(t.settings.classes[t.settings.type])},activeClass:function(){var n=t.settings.classes,i=e.Html.slides[t.index];i&&(i.classList.add(n.activeSlide),S(i).forEach((function(t){t.classList.remove(n.activeSlide)})))},removeClasses:function(){var n=t.settings.classes;e.Html.root.classList.remove(n[t.settings.type]),e.Html.slides.forEach((function(t){t.classList.remove(n.activeSlide)}))}};return n.on(["destroy","update"],(function(){i.removeClasses()})),n.on(["resize","update"],(function(){i.mount()})),n.on("move.after",(function(){i.activeClass()})),i},Run:function(t,e,n){var i={mount:function(){this._o=!1},make:function(i){var r=this;t.disabled||(t.disable(),this.move=i,n.emit("run.before",this.move),this.calculate(),n.emit("run",this.move),e.Transition.after((function(){r.isStart()&&n.emit("run.start",r.move),r.isEnd()&&n.emit("run.end",r.move),(r.isOffset("<")||r.isOffset(">"))&&(r._o=!1,n.emit("run.offset",r.move)),n.emit("run.after",r.move),t.enable()})))},calculate:function(){var e=this.move,n=this.length,i=e.steps,o=e.direction,a=function(t){return"number"==typeof t}(d(i))&&0!==d(i);switch(o){case">":">"===i?t.index=n:this.isEnd()?t.isType("slider")&&!t.settings.rewind||(this._o=!0,t.index=0):a?t.index+=Math.min(n-t.index,-d(i)):t.index++;break;case"<":"<"===i?t.index=0:this.isStart()?t.isType("slider")&&!t.settings.rewind||(this._o=!0,t.index=n):a?t.index-=Math.min(t.index,d(i)):t.index--;break;case"=":t.index=i;break;default:r("Invalid direction pattern ["+o+i+"] has been used")}},isStart:function(){return 0===t.index},isEnd:function(){return t.index===this.length},isOffset:function(t){return this._o&&this.move.direction===t}};return v(i,"move",{get:function(){return this._m},set:function(t){var e=t.substr(1);this._m={direction:t.substr(0,1),steps:e?d(e)?d(e):e:0}}}),v(i,"length",{get:function(){var n=t.settings,i=e.Html.slides.length;return t.isType("slider")&&"center"!==n.focusAt&&n.bound?i-1-(d(n.perView)-1)+d(n.focusAt):i-1}}),v(i,"offset",{get:function(){return this._o}}),i},Swipe:function(t,e,n){var i=new T,r=0,o=0,a=0,s=!1,u=!!M&&{passive:!0},c={mount:function(){this.bindSwipeStart()},start:function(e){if(!s&&!t.disabled){this.disable();var i=this.touches(e);r=null,o=d(i.pageX),a=d(i.pageY),this.bindSwipeMove(),this.bindSwipeEnd(),n.emit("swipe.start")}},move:function(i){if(!t.disabled){var s=t.settings,u=s.touchAngle,c=s.touchRatio,l=s.classes,f=this.touches(i),p=d(f.pageX)-o,h=d(f.pageY)-a,m=Math.abs(p<<2),v=Math.abs(h<<2),g=Math.sqrt(m+v),b=Math.sqrt(v);if(!(180*(r=Math.asin(b/g))/Math.PI<u))return!1;i.stopPropagation(),e.Move.make(p*function(t){return parseFloat(t)}(c)),e.Html.root.classList.add(l.dragging),n.emit("swipe.move")}},end:function(i){if(!t.disabled){var a=t.settings,s=this.touches(i),u=this.threshold(i),c=s.pageX-o,l=180*r/Math.PI,f=Math.round(c/e.Sizes.slideWidth);this.enable(),c>u&&l<a.touchAngle?(a.perTouch&&(f=Math.min(f,d(a.perTouch))),e.Direction.is("rtl")&&(f=-f),e.Run.make(e.Direction.resolve("<"+f))):c<-u&&l<a.touchAngle?(a.perTouch&&(f=Math.max(f,-d(a.perTouch))),e.Direction.is("rtl")&&(f=-f),e.Run.make(e.Direction.resolve(">"+f))):e.Move.make(),e.Html.root.classList.remove(a.classes.dragging),this.unbindSwipeMove(),this.unbindSwipeEnd(),n.emit("swipe.end")}},bindSwipeStart:function(){var n=this,r=t.settings;r.swipeThreshold&&i.on(E[0],e.Html.wrapper,(function(t){n.start(t)}),u),r.dragThreshold&&i.on(E[1],e.Html.wrapper,(function(t){n.start(t)}),u)},unbindSwipeStart:function(){i.off(E[0],e.Html.wrapper,u),i.off(E[1],e.Html.wrapper,u)},bindSwipeMove:function(){var n=this;i.on(H,e.Html.wrapper,k((function(t){n.move(t)}),t.settings.throttle),u)},unbindSwipeMove:function(){i.off(H,e.Html.wrapper,u)},bindSwipeEnd:function(){var t=this;i.on(j,e.Html.wrapper,(function(e){t.end(e)}))},unbindSwipeEnd:function(){i.off(j,e.Html.wrapper)},touches:function(t){return D.indexOf(t.type)>-1?t:t.touches[0]||t.changedTouches[0]},threshold:function(e){var n=t.settings;return D.indexOf(e.type)>-1?n.dragThreshold:n.swipeThreshold},enable:function(){return s=!1,e.Transition.enable(),this},disable:function(){return s=!0,e.Transition.disable(),this}};return n.on("build.after",(function(){e.Html.root.classList.add(t.settings.classes.swipeable)})),n.on("destroy",(function(){c.unbindSwipeStart(),c.unbindSwipeMove(),c.unbindSwipeEnd(),i.destroy()})),c},Images:function(t,e,n){var i=new T,r={mount:function(){this.bind()},bind:function(){i.on("dragstart",e.Html.wrapper,this.dragstart)},unbind:function(){i.off("dragstart",e.Html.wrapper)},dragstart:function(t){t.preventDefault()}};return n.on("destroy",(function(){r.unbind(),i.destroy()})),r},Anchors:function(t,e,n){var i=new T,r=!1,o=!1,a={mount:function(){this._a=e.Html.wrapper.querySelectorAll("a"),this.bind()},bind:function(){i.on("click",e.Html.wrapper,this.click)},unbind:function(){i.off("click",e.Html.wrapper)},click:function(t){o&&(t.stopPropagation(),t.preventDefault())},detach:function(){if(o=!0,!r){for(var t=0;t<this.items.length;t++)this.items[t].draggable=!1,this.items[t].setAttribute("data-href",this.items[t].getAttribute("href")),this.items[t].removeAttribute("href");r=!0}return this},attach:function(){if(o=!1,r){for(var t=0;t<this.items.length;t++)this.items[t].draggable=!0,this.items[t].setAttribute("href",this.items[t].getAttribute("data-href"));r=!1}return this}};return v(a,"items",{get:function(){return a._a}}),n.on("swipe.move",(function(){a.detach()})),n.on("swipe.end",(function(){e.Transition.after((function(){a.attach()}))})),n.on("destroy",(function(){a.attach(),a.unbind(),i.destroy()})),a},Controls:function(t,e,n){var i=new T,r=!!M&&{passive:!0},o={mount:function(){this._n=e.Html.root.querySelectorAll('[data-glide-el="controls[nav]"]'),this._c=e.Html.root.querySelectorAll('[data-glide-el^="controls"]'),this.addBindings()},setActive:function(){for(var t=0;t<this._n.length;t++)this.addClass(this._n[t].children)},removeActive:function(){for(var t=0;t<this._n.length;t++)this.removeClass(this._n[t].children)},addClass:function(e){var n=t.settings,i=e[t.index];i&&(i.classList.add(n.classes.activeNav),S(i).forEach((function(t){t.classList.remove(n.classes.activeNav)})))},removeClass:function(e){var n=e[t.index];n&&n.classList.remove(t.settings.classes.activeNav)},addBindings:function(){for(var t=0;t<this._c.length;t++)this.bind(this._c[t].children)},removeBindings:function(){for(var t=0;t<this._c.length;t++)this.unbind(this._c[t].children)},bind:function(t){for(var e=0;e<t.length;e++)i.on("click",t[e],this.click),i.on("touchstart",t[e],this.click,r)},unbind:function(t){for(var e=0;e<t.length;e++)i.off(["click","touchstart"],t[e])},click:function(t){t.preventDefault(),e.Run.make(e.Direction.resolve(t.currentTarget.getAttribute("data-glide-dir")))}};return v(o,"items",{get:function(){return o._c}}),n.on(["mount.after","move.after"],(function(){o.setActive()})),n.on("destroy",(function(){o.removeBindings(),o.removeActive(),i.destroy()})),o},Keyboard:function(t,e,n){var i=new T,r={mount:function(){t.settings.keyboard&&this.bind()},bind:function(){i.on("keyup",document,this.press)},unbind:function(){i.off("keyup",document)},press:function(t){39===t.keyCode&&e.Run.make(e.Direction.resolve(">")),37===t.keyCode&&e.Run.make(e.Direction.resolve("<"))}};return n.on(["destroy","update"],(function(){r.unbind()})),n.on("update",(function(){r.mount()})),n.on("destroy",(function(){i.destroy()})),r},Autoplay:function(t,e,n){var i=new T,r={mount:function(){this.start(),t.settings.hoverpause&&this.bind()},start:function(){var n=this;t.settings.autoplay&&h(this._i)&&(this._i=setInterval((function(){n.stop(),e.Run.make(">"),n.start()}),this.time))},stop:function(){this._i=clearInterval(this._i)},bind:function(){var t=this;i.on("mouseover",e.Html.root,(function(){t.stop()})),i.on("mouseout",e.Html.root,(function(){t.start()}))},unbind:function(){i.off(["mouseover","mouseout"],e.Html.root)}};return v(r,"time",{get:function(){return d(e.Html.slides[t.index].getAttribute("data-glide-autoplay")||t.settings.autoplay)}}),n.on(["destroy","update"],(function(){r.unbind()})),n.on(["run.before","pause","destroy","swipe.start","update"],(function(){r.stop()})),n.on(["run.after","play","swipe.end"],(function(){r.start()})),n.on("update",(function(){r.mount()})),n.on("destroy",(function(){i.destroy()})),r},Breakpoints:function(t,e,n){var i=new T,r=t.settings,o=B(r.breakpoints),a=u({},r),s={match:function(t){if(void 0!==window.matchMedia)for(var e in t)if(t.hasOwnProperty(e)&&window.matchMedia("(max-width: "+e+"px)").matches)return t[e];return a}};return u(r,s.match(o)),i.on("resize",window,k((function(){t.settings=g(r,s.match(o))}),t.settings.throttle)),n.on("update",(function(){o=B(o),a=u({},r)})),n.on("destroy",(function(){i.off("resize",window)})),s}},q=function(t){function e(){return a(this,e),c(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,y),s(e,[{key:"mount",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return function t(e,n,i){null===e&&(e=Function.prototype);var r=Object.getOwnPropertyDescriptor(e,n);if(void 0===r){var o=Object.getPrototypeOf(e);return null===o?void 0:t(o,n,i)}if("value"in r)return r.value;var a=r.get;return void 0!==a?a.call(i):void 0}(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),"mount",this).call(this,u({},z,t))}}]),e}();e.default=q}});
